import React from "react";
import PropTypes from "prop-types";

import styles from "./style.module.scss";
import { SimManager } from "@learningblocks/simulation-engine";
import { ModalManager } from "@learningblocks/simulation-engine";

/**
 * ProtocolChapter Component.
 * Renders the protocol chapter scene.
 *
 * @prop {Object} [protocolChapter] - Represents the state of the protocolChapter section.
 *
 */

const DIMENSIONS = {
  width: 1350,
  height: 600,
};

export class ProtocolChapter extends React.Component {
  constructor(props) {
    super(props);
    if (props.dimensions) {
      this.dimensions = this.props.dimensions;
    }
    this.state = {
      userScale: this.props.userScale,
      sceneScale: this.props.sceneScale,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }

  getDimensions = () => this.dimensions || DIMENSIONS;

  handleResize = () => {
    const height = window.innerHeight;
    const width = window.innerWidth;
    console.log("h>>", height, "w>>", width);
    const heightRatio = height / this.getDimensions().height;
    const widthRatio = width / this.getDimensions().width;
    const scale = Math.min(heightRatio, widthRatio);
    const left = Math.max((width - this.getDimensions().width * scale) / 2, 0);
    const bottom = Math.min(
      (this.getDimensions().height * scale - height) / 2,
      0
    );
    this.setState({
      scale,
      bottom,
      left,
      sceneScale: scale,
    });
    SimManager.getInstance().setScales(this.state.userScale, scale);
  };

  render() {
    if (!SimManager.getInstance().initialized) {
      SimManager.getInstance().setScales(
        this.state.userScale,
        this.state.sceneScale
      );
      SimManager.getInstance().loadDatafromJson(
        this.props.simData,
        this.props.stepsData
      );
    }

    const IOItems = SimManager.getInstance().getInteractableObjects();
    const modal = ModalManager.getInstance().getCurrentModal();

    return (
      <div className={styles.dragdropContainer}>
        <div
          id="dragdrop-holder"
          className={styles.dragdropHolder}
          ref={(divElement) => {
            this.divElement = divElement;
          }}
        >
          <div
            id="dragdrop"
            className={styles.dragdrop}
            data-scene-width={this.getDimensions().width}
            data-scene-height={this.getDimensions().height}
            style={{
              transform: `scale(${this.state.scale})`,
              bottom: this.state.bottom,
              left: this.state.left,
            }}
          >
            {IOItems}
            {modal}
          </div>
        </div>
      </div>
    );
  }
}

// Prop types for the ProtocolChapter component
ProtocolChapter.propTypes = {
  userScale: PropTypes.number,
  sceneScale: PropTypes.number,
  simData: PropTypes.object.isRequired,
  stepsData: PropTypes.object.isRequired,
  dimensions: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
};

// Default props for the ProtocolChapter component
ProtocolChapter.defaultProps = {};
